import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

const Footer = () => {
  const year = moment().format('YYYY')
  return (
    <div className='footer'>
      <p className='mb-0'>
        Copyright &#169; {year} <Link to='/dashboard'>Intra-Africa</Link>. All
        Right reserved.
      </p>
    </div>
  )
}

export default Footer
